// src/redux/slices/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBusinessUserProfileImageUrl } from "../../../Components/utils/buserimageUtils"; // if you have helper

// 🔄 Thunk to fetch user data from JWT-based profile route
export const fetchUserData = createAsyncThunk(
  "businessUserProfile/fetchUserData",
  async (_, { rejectWithValue }) => {
    // no userId param needed
    try {
      const token = localStorage.getItem("token");
      if (!token) return rejectWithValue("Missing token");

      const baseUrl =
        process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";
      const response = await fetch(`${baseUrl}/business/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch user data");

      const data = await response.json();
      console.log("Fetched raw user data from API:", data);

      if (!data?.user) {
        return rejectWithValue("User data missing in API response");
      }

      // Use helper to ensure profilePic URL is correct
      const profilePicUrl = getBusinessUserProfileImageUrl(
        data.user.profilePic,
      );

      const userData = {
        ...data.user,
        profilePicUrl, // frontend can directly use this
      };

      console.log("✅ Processed User Data:", userData);

      return userData;
    } catch (err) {
      console.error("❌ Error fetching user data:", err);
      return rejectWithValue(err.message);
    }
  },
);

// 🧩 Slice
const userSlice = createSlice({
  name: "businessUserProfile",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
